import React, { useState } from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';
import YearStructurePeriodEditor from './YearStructurePeriodEditor';

const PeriodEditModal = ({
    isOpen,
    onClose,
    period = null,
    onSuccess,
    onDelete,
    setError
}) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const isEditMode = period != null;

    const handleClose = () => {
        setShowDeleteConfirm(false);
        onClose();
    };

    const handleSuccess = (result) => {
        if (onSuccess) onSuccess(result);
        handleClose();
    };

    const handleDelete = async () => {
        if (!period || !onDelete) return;

        setIsDeleting(true);
        try {
            await onDelete(period.id);
            handleClose();
        } catch (error) {
            console.error('Error deleting period:', error);
            alert(`Failed to delete period: ${error.message}`);
        } finally {
            setIsDeleting(false);
            setShowDeleteConfirm(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            title={isEditMode ? `Edit Period: ${period?.name}` : 'Create New Period'}
            containerClassName="max-w-3xl max-h-[80vh]"
        >
            <div className="space-y-4">
                {showDeleteConfirm ? (
                    <div className="space-y-4">
                        <div className="bg-red-50 border border-red-200 rounded p-4">
                            <p className="text-red-800 font-medium">
                                Are you sure you want to delete this period?
                            </p>
                            <p className="text-red-700 text-sm mt-2">
                                This action cannot be undone. All schedule entries associated with this period may be affected.
                            </p>
                        </div>

                        <div className="flex justify-end gap-2">
                            <Button
                                variant="secondary"
                                onClick={() => setShowDeleteConfirm(false)}
                                disabled={isDeleting}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="danger"
                                onClick={handleDelete}
                                disabled={isDeleting}
                            >
                                {isDeleting ? 'Deleting...' : 'Delete Period'}
                            </Button>
                        </div>
                    </div>
                ) : (
                    <>
                        <YearStructurePeriodEditor
                            key={period?.id ?? 'create'}
                            period={period}
                            variant="compact"
                            hideHeading
                            setError={setError}
                            onSuccess={handleSuccess}
                            onCancel={handleClose}
                        />

                        {isEditMode && onDelete && (
                            <div className="flex justify-start pt-1">
                                <Button
                                    variant="danger"
                                    onClick={() => setShowDeleteConfirm(true)}
                                    disabled={isDeleting}
                                >
                                    Delete Period
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </Modal>
    );
};

export default PeriodEditModal;
